import "./navFooter.scss";
import logo from "./images/sbc_25.webp";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, Fade } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export default function Nav() {
  const navigate = useNavigate();
  const [showBtn, setShowBtn] = useState(false);
  const [showSmall, setShowSmall] = useState(false);
  const [showCartNav, setShowCartNav] = useState(false);
  // MOBILE MENU
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleNavClick = (sectionId) => {
    navigate("/", { state: { scrollTo: sectionId } });
  };
  const handleClose = (url) => {
    setAnchorEl(null);
    document.getElementById(url).scrollIntoView();
  };

  useEffect(() => {
    const page = new URL(window.location);
    if (
      page.pathname === "/early-bird-thanks" ||
      page.pathname === "/early-bird" ||
      page.pathname === "/map" ||
      page.pathname === "/next-sbc" ||
      page.pathname === "/privacy-policy" ||
      page.pathname === "/upgrade" ||
      page.pathname === "/upgrade-thanks" ||
      page.pathname === "/competition" ||
      page.pathname === "/competition-tncs" ||
      page.pathname === "/competition-thanks" ||
      page.pathname === "/faq" ||
      page.pathname === "faq" ||
      page.pathname === "/thank-you" ||
      page.pathname === "thank-you" ||
      page.pathname === "cart" ||
      page.pathname === "/cart" ||
      page.pathname === "/sponsors" ||
      page.pathname === "sponsors" ||
      page.pathname === "/affiliate" ||
      page.pathname === "affiliate" ||
      page.pathname === "/voting" ||
      page.pathname === "/vote-thank-you" ||
      page.pathname.startsWith("/affiliate/")
    ) {
      setShowBtn(false);
    } else {
      setShowBtn(true);
    }

    if (page.pathname === "cart" || page.pathname === "/cart") {
      setShowCartNav(true);
    } else {
      setShowCartNav(false);
    }
  });

  useEffect(() => {
    if (window.innerWidth < 850) {
      setShowSmall(true);
    }
  }, [window.innerWidth]);

  const scroll = (id) => {
    document.getElementById(id).scrollIntoView();
  };

  return (
    <>
      {/* {showBtn ? (
        <section className="animated-text-strip">
          <p className="marquee">
            Find the 4 hidden cones to get a discount code
          </p>
          <p className="marquee">
            Find the 4 hidden cones to get a discount code
          </p>
          <p className="marquee">
            Find the 4 hidden cones to get a discount code
          </p>
          <p className="marquee">
            Find the 4 hidden cones to get a discount code
          </p>
        </section>
      ) : null} */}
      {!showCartNav ? (
        <section className="nav">
          <img
            src={logo}
            alt="Scottish Business Conference"
            onClick={() => navigate("/")}
          />
          {!showSmall ? (
            <nav>
              {/* <strong onClick={() => handleNavClick("tickets")}>Tickets</strong> */}
              <strong onClick={() => handleNavClick("speakers")}>
                Speakers
              </strong>
              <strong onClick={() => handleNavClick("faq")}>FAQ</strong>
            </nav>
          ) : (
            <nav>
              <strong onClick={() => handleNavClick("tickets")}>Tickets</strong>
              <strong onClick={() => handleNavClick("speakers")}>
                Speakers
              </strong>
              <strong onClick={() => handleNavClick("faq")}>FAQ</strong>

              {/* <Button
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{ color: "#fff" }}
              >
                Menu
              </Button>
              <Menu
                id="fade-menu"
                MenuListProps={{
                  "aria-labelledby": "fade-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                <MenuItem onClick={() => handleClose("/")}>
                  Event Details
                </MenuItem>
                <MenuItem onClick={() => handleClose("#tickets")}>
                  Tickets
                </MenuItem>
                <MenuItem onClick={() => handleClose("#speakers")}>
                  Speakers
                </MenuItem>
                <MenuItem onClick={() => handleClose("#faq")}>FAQ</MenuItem>
              </Menu> */}
            </nav>
          )}
          {/* {showBtn ? (
            <button className="countdown" onClick={() => scroll("tickets")}>
              GET YOUR TICKET
            </button>
          ) : null} */}
        </section>
      ) : (
        <section className="cart-header">
          <div className="checkout-securely">
            <ShoppingCartIcon className="cart-icon" />
            <h4>Checkout Securely</h4>
          </div>{" "}
          <img
            src={logo}
            alt="Scottish Business Conference"
            onClick={() => navigate("/")}
          />
        </section>
      )}
    </>
  );
}
